import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import UserAvatar from './UserAvatar';
import { useLanguage } from '../contexts/LanguageContext';
import './MobileModals.css';

function LikedByModal({ likedBy, onClose }) {
  const { t } = useLanguage();
  const [modalRoot, setModalRoot] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    let root = document.getElementById('modal-root');
    if (!root) {
      root = document.createElement('div');
      root.id = 'modal-root';
      document.body.appendChild(root);
    }
    setModalRoot(root);
    return () => {
      if (root && root.childNodes.length === 0) {
        document.body.removeChild(root);
      }
    };
  }, []);

  useEffect(() => {
    document.body.classList.add('modal-open');
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.classList.remove('modal-open');
    };
  }, [onClose]);

  if (!modalRoot) return null;

  const getModalWidth = () => {
    if (isMobile) return '100%';
    return Math.min(Math.floor(window.innerWidth * 0.33), 480) + 'px';
  };

  return createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-container"
        style={{ maxWidth: getModalWidth() }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="card border-0 h-100 d-flex flex-column">
          <div className="card-header bg-white d-flex justify-content-between align-items-center py-2">
            <h5 className="card-title mb-0" style={{ fontSize: isMobile ? '1rem' : '1.25rem' }}>
              {t('events.likes.likedBy') || 'Liked by'}
            </h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>

          <div
            className="card-body p-2 p-md-3 overflow-auto"
            style={{ maxHeight: isMobile ? 'calc(85vh - 120px)' : '400px' }}
          >
            {likedBy.length > 0 ? (
              <div className="list-group list-group-flush">
                {likedBy.map((user) => (
                  <div key={user.user_id} className="list-group-item border-0 px-1 py-2">
                    <UserAvatar
                      profileImage={user.profile_image}
                      displayName={user.display_name}
                      size={36}
                    />
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-3 text-muted">
                <div className="spinner-border spinner-border-sm" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            )}
          </div>

          <div className="card-footer bg-white d-flex justify-content-end py-2">
            <button
              type="button"
              className={`btn btn-secondary ${isMobile ? 'btn-sm' : ''}`}
              onClick={onClose}
            >
              {t('events.modals.attendees.close') || 'Close'}
            </button>
          </div>
        </div>
      </div>
    </div>,
    modalRoot
  );
}

export default LikedByModal;
